import { hostsConfig } from 'init/config'
import { loadCss, loadJs } from 'util/browser-utils'
import { waitForValue } from 'util/ts-utils'

const BASE_CSS_ID = 'tt-base-css'
const BASE_JS_ID = 'tt-base-js'
const PAGE_CSS_ID = 'tt-page-css'
const PAGE_JS_ID = 'tt-page-js'
const SVG_CONTAINER_ID = 'tt-svg-icons'


let widgetsHostUrl = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/v5/widgets`
if (process.env.NODE_ENV === 'development') {
  widgetsHostUrl = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}`
}

// The requireContext is passed in by the page entry file. It should be a context that points to
// the directory the svgs are located in. Example:
// loadIcons(require.context('assets/svg', true, /.svg$/))
export function loadIcons(requireContext) {
  const symbols = requireContext.keys().reduce((accumulator, key) => {
    return accumulator + requireContext(key)
  }, '')
  const div = document.createElement('div')
  div.id = SVG_CONTAINER_ID
  div.style.display = 'none'
  div.style.width = '0'
  div.style.height = '0'
  waitForValue(() => document.body).then(() => {
    document.body.insertBefore(div, document.body.childNodes[0])
    div.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
      symbols + '</svg>'
  })
}

export function loadBaseCss(cssFilePath) {
  loadCss(`${widgetsHostUrl}${cssFilePath}`, BASE_CSS_ID)
}

export function loadPageCss(cssFilePath) {
  loadCss(`${widgetsHostUrl}${cssFilePath}`, PAGE_CSS_ID)
}

export function loadBaseJs(jsFilePath) {
  loadJs(`${widgetsHostUrl}${jsFilePath}`, BASE_JS_ID)
}

export function loadPageJs(jsFilePath) {
  loadJs(`${widgetsHostUrl}${jsFilePath}`, PAGE_JS_ID)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/init/resource-loader.ts